import { Injectable } from "@angular/core";

import { ProfiloDTO } from "@app/shared/dto/profiloDTO";
import { SettoreDTO } from "@app/shared/dto/settoreDTO";

import { ProfiloVO } from "@app/shared/vo/profiloVO";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";

import { MapperSettore } from "@app/shared/mapper/mapper-settore";

import { MapperAutorizzazione } from "@app/shared/mapper/mapper-autorizzazione";

@Injectable({
  providedIn: "root"
})
export class MapperProfilo implements MapperInterface<ProfiloDTO, ProfiloVO> {
  constructor(
    private mapperSettore: MapperSettore,
    private mapperAutorizzazione: MapperAutorizzazione
  ) { }

  convertVoToDto(profiloVO: ProfiloVO): ProfiloDTO {
    // console.log("[MapperProfilo] ProfiloVO => ProfiloDTO");

    const profiloDTO = new ProfiloDTO();
    profiloDTO.nome = profiloVO.nome;
    profiloDTO.codice = profiloVO.codice;
    profiloDTO.settori = this.mapperSettore.convertListVoToDto(
      profiloVO.settori
    );
    profiloDTO.autorizzazioni = this.mapperAutorizzazione.convertListVoToDto(
      profiloVO.autorizzazioni
    );

    return profiloDTO || new ProfiloDTO();
  }

  convertDtoToVo(profiloDTO: ProfiloDTO): ProfiloVO {
    // console.log("[MapperProfilo] ProfiloVO => ProfiloDTO");

    const profiloVO = new ProfiloVO();
    profiloVO.nome = profiloDTO.nome;
    profiloVO.codice = profiloDTO.codice;
    profiloVO.settori = this.mapperSettore.convertListDtoToVo(
      profiloDTO.settori
    );
    profiloVO.autorizzazioni = this.mapperAutorizzazione.convertListDtoToVo(
      profiloDTO.autorizzazioni
    );

    return profiloVO || new ProfiloVO();
  }

  convertListVoToDto(profiloVOList: ProfiloVO[]): ProfiloDTO[] {
    // console.log("[MapperProfilo] profiloDTOList => profiloVOList");
    const profiloDTOList = new Array<ProfiloDTO>();
    if (profiloVOList != null) {
      profiloVOList.forEach(vo => {
        profiloDTOList.push(this.convertVoToDto(vo));
      });
    }
    return profiloDTOList || new Array<ProfiloDTO>();
  }

  convertListDtoToVo(profiloDTOList: ProfiloDTO[]): ProfiloVO[] {
    // console.log("[MapperProfilo] profiloDTOList => profiloVOList");
    const profiloVOList = new Array<ProfiloVO>();
    if (profiloDTOList != null) {
      profiloDTOList.forEach(dto => {
        profiloVOList.push(this.convertDtoToVo(dto));
      });
    }
    return profiloVOList || new Array<ProfiloVO>();
  }
}
